// import {
//   APP_NAME,
// } from './base';

const APP_NAME = 'tasks'; // TODO:: Use from base.js
const JOB_TEMPLATES = 'job-templates';
const TASKS = 'tasks';
const JOBS = 'jobs';

const SETTINGS = 'settings';
const TEAMS = 'teams';

const CREATE = 'create';
const EDIT = 'edit';
const VIEW = 'view';

export const getJobTemplatesListUrl = () => (`/${APP_NAME}/${JOB_TEMPLATES}`);
export const getJobTemplatesViewUrl = (id) => (`/${APP_NAME}/${JOB_TEMPLATES}/${id}/${VIEW}`);
export const getJobTemplatesCreateUrl = () => (`/${APP_NAME}/${JOB_TEMPLATES}/${CREATE}`);
export const getJobTemplatesEditUrl = (id, search = '') => (`/${APP_NAME}/${JOB_TEMPLATES}/${id}/${EDIT}/${search}`);

export const getTaskListUrl = () => (`/${APP_NAME}/${TASKS}`);
export const getTaskViewUrl = (id) => (`/${APP_NAME}/${TASKS}/${id}/${VIEW}`);
export const getTaskCreateUrl = () => (`/${APP_NAME}/${TASKS}/${CREATE}`);
export const getTaskEditUrl = (id, search = '') => (`/${APP_NAME}/${TASKS}/${id}/${EDIT}/${search}`);

export const getJobListUrl = () => (`/${APP_NAME}/${JOBS}`);
export const getJobViewUrl = (id) => (`/${APP_NAME}/${JOBS}/${id}/${VIEW}`);
export const getJobCreateUrl = (id) => (`/${APP_NAME}/${JOBS}/${CREATE}/${JOB_TEMPLATES}/${id}`);
export const getJobEditUrl = (id, search = '') => (`/${APP_NAME}/${JOBS}/${id}/${EDIT}/${search}`);

export const getTeamListUrl = () => (`/${SETTINGS}/${APP_NAME}/${TEAMS}`);
export const getTeamViewUrl = (id) => (`/${SETTINGS}/${APP_NAME}/${TEAMS}/${id}/${VIEW}`);
export const getTeamCreateUrl = () => (`/${SETTINGS}/${APP_NAME}/${TEAMS}/${CREATE}`);
export const getTeamEditUrl = (id, search = '') => (`/${SETTINGS}/${APP_NAME}/${TEAMS}/${id}/${EDIT}/${search}`);
